module.exports = __webpack_public_path__ + "media/images/lp/1/donation1-title-pc-d4276bc860210a4bd5c3b5e9f03f782b.png";